module.exports = __webpack_public_path__ + "static/media/report.21af5371.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/report.png
// module id = 766
// module chunks = 0